import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { RolePermission } from './role-permission'
import { rolePermissionActions } from './role-permission.actions'
import * as fromRolePermission from './role-permission.reducer'
import { RolePermissionService } from './role-permission.service'

@Injectable()
export class RolePermissionEffects extends ResourceEffects<RolePermission> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public rolePermissionService: RolePermissionService
  ) {
    super(
      fromRolePermission.FEATURE_NAME,
      rolePermissionService,
      rolePermissionActions,
      actions$
    )
  }
}
